export const ssoURL = process.env.CONFIG_ENV === 'production' || process.env.CONFIG_ENV === 'staging' ? 'https://sso.agi-eval.cn' : 'https://sso.adp.test.sankuai.com';
